define.alias("ember-composable-helpers/helpers/find-by", "settings/helpers/find-by");